import { ATMOSPHERE_PLATES, type AtmospherePlateId } from '../atmosphere';
import { useSaveData } from '../useSaveData';

type AtmosphericLayerProps = {
  plate: AtmospherePlateId;
  /** Placement modifier, e.g. `story`, `capability`, `contact`. */
  placement: string;
};

/**
 * Decorative depth layer that carries the hero's cinematic atmosphere into the
 * sections below it. Under Save-Data the media is dropped and the layer falls
 * back to its tonal plane, so the depth ladder still reads.
 */
export function AtmosphericLayer({ plate, placement }: AtmosphericLayerProps) {
  const saveData = useSaveData();
  const source = ATMOSPHERE_PLATES[plate];

  return (
    <div
      className={`atmosphere atmosphere--${placement}`}
      data-plate={saveData ? 'tone' : 'media'}
      aria-hidden="true"
    >
      {!saveData && (
        <picture className="atmosphere__media">
          <source media="(max-width: 640px)" srcSet={source.portrait} />
          <img src={source.desktop} alt="" loading="lazy" decoding="async" />
        </picture>
      )}
    </div>
  );
}
